import { ReturnCategory, ReturnStatus } from '@invenco/supply-interface';

import type { ReturnsQueryQuery } from '@/graphql/generated/seller/graphql';
import { convertDateTimeToISO, getEnumValue } from '@/shared/helpers';
import { ListData } from '@/shared/types';

export type ReturnListItem = {
  id: string;
  name: string;
  orderName?: string;
  customerName?: string;
  category?: ReturnCategory;
  status?: ReturnStatus;
  createdAt: string;
  locationName?: string;
  closedAt?: string;
};

export class ReturnListMapper {
  private static getClosedAt(rawValue: string) {
    const isoClosedAt = convertDateTimeToISO(rawValue);
    return isoClosedAt === '1970-01-01T00:00:00.000Z' ? undefined : isoClosedAt;
  }

  static toData(response: ReturnsQueryQuery): ListData<ReturnListItem> {
    const total = response?.returnsAggregate?._count ?? 0;
    const data = Array.isArray(response.returns)
      ? response.returns.map((returnItem) => ({
          id: returnItem.id,
          name: returnItem.name,
          orderName: returnItem.order?.name || undefined,
          customerName: returnItem.fromAddressContactName || undefined,
          category: returnItem.returnCategory
            ? getEnumValue(ReturnCategory, returnItem.returnCategory)
            : undefined,
          status: returnItem.status ? getEnumValue(ReturnStatus, returnItem.status) : undefined,
          createdAt: convertDateTimeToISO(returnItem.createdAt),
          locationName: returnItem.location?.name || undefined,
          closedAt: ReturnListMapper.getClosedAt(returnItem.closedAt),
        }))
      : [];

    return {
      data,
      total,
    };
  }
}
